import Model from './model.js';

export default class EducationCurrentData extends Model
{
    constructor(id, personId, educationalLevel, department, school, major, stage, admissionChannel, studyType, shiftType, isContinuous, reason, dateLeave, isWantReturn, note){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.educationalLevel   = educationalLevel;
        this.department         = department;
        this.school             = school;
        this.major              = major;
        this.stage              = stage;
        this.admissionChannel   = admissionChannel;
        this.studyType          = studyType;
        this.shiftType          = shiftType;
        this.isContinuous       = isContinuous;
        this.reason             = reason;
        this.dateLeave          = dateLeave;
        this.isWantReturn       = isWantReturn;
        this.note              = note;

        this.init()
    }
       
    update(data){
        Object.assign(this, data)
    }
}

